import pkg from '../../package.json';

export const VERSION_NUMBER = pkg.version;
